module.exports = __webpack_public_path__ + "static/media/myauchan.ae4ecbf8.png";